import { ChannelLayout } from "src/types.g";
import styled from "styled-components";

interface CoverOverlayProps {
  layout: ChannelLayout;
  coverColor: string;
}

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px;
  background: white;
  border: 2px solid black;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
  transition: opacity 0.2s ease-in-out;
  z-index: 10;
  border-radius: 8px;
  .layout-card:hover & {
    opacity: 0;
  }
`;

const Row = styled.div`
  display: flex;
  gap: 2px;
  flex: 1;
`;

const Zone = styled.div<{ coverColor: string }>`
  background: ${({ coverColor }) => coverColor};
`;

const FullZone = styled(Zone)`
  flex: 1;
`;

const MainZone = styled(Zone)`
  flex: 3;
`;

const SideZone = styled(Zone)`
  flex: 1;
`;

const BottomZone = styled(Zone)`
  flex: 1;
`;

export const CoverOverlay = (props: CoverOverlayProps): JSX.Element => {
  const { layout, coverColor } = props;
  switch (layout) {
    case ChannelLayout.OneZone:
      return (
        <Container>
          <FullZone coverColor={coverColor} />
        </Container>
      );
    case ChannelLayout.ThreeZone:
      return (
        <Container>
          <Row style={{ flex: 3 }}>
            {" "}
            {/* Main row takes more space */}
            <MainZone coverColor={coverColor} />
            <SideZone coverColor={coverColor} />
          </Row>
          <Row style={{ flex: 1 }}>
            {" "}
            {/* Bottom row is smaller */}
            <BottomZone style={{ flex: 1 }} coverColor={coverColor} />
          </Row>
        </Container>
      );
    case ChannelLayout.FourZone:
      return (
        <Container>
          <Row style={{ flex: 3 }}>
            {" "}
            {/* Main row takes more space */}
            <MainZone coverColor={coverColor} />
            <SideZone coverColor={coverColor} />
          </Row>
          <Row style={{ flex: 1 }}>
            {" "}
            {/* Bottom row is smaller */}
            <Zone style={{ flex: 3 }} coverColor={coverColor} />{" "}
            {/* Matches width of MainZone above */}
            <SideZone coverColor={coverColor} />
          </Row>
        </Container>
      );
  }
};
